<div class="flxClmn dashboard-page" style="position: relative;">
	<div class="page-title-container flxClmn-center" style="z-index: 45;">
		<div class="page-title-inner-container flxRow">
			<span class="page-title">Overview</span>
		</div>
		<div class="page-subtitle-container flxRow-between hSpace4">
			<span class="page-subtitle f-1-0">Users, resources, threats and data protection across your collaboration environment</span>
		</div>
	</div>

	<div class="page-inner-content-holder bs-enabled" style="background: white; padding-top: 0; position: relative;">
		<!--Top bar: Tabs + Period dropdown-->
		<div class="flex-column gap-2">
			<!--Tabs-->
			<div class="flxRow-between align-items-center">
				<div class="md-tabs" style="--md-tabs-width: 150px">
					<ng-container *ngFor="let tab of tabs | keyvalue: gs.returnZero">
						<div [ngClass]="{'selected' : activeTab === tab.value}" (click)="activeTab = tab.value">
							<input type="radio" name="tabs" id="{{tab.key}}Toggle" [checked]="activeTab === tab.value">
							<label for="{{tab.key}}Toggle">
								<span>{{tab.value | camelCaseToTitleCase}}</span>
							</label>
						</div>
					</ng-container>

					<div class="slide" [ngStyle]="{'left' : 150 * getVisibleTabIndex(activeTab) + 'px' || 0}"></div>
				</div>
				<btn-c style="width: 140px;"
					   endIcon="fas fa-chart-pie" variant="outlined"
					   (action)="generateReportAction();">
					Generate Report
				</btn-c>
			</div>
			<!---->

			<!--Period buttons-->
			<div class="flex-row justify-content-between align-items-center mt-2 ms-3">
				<div class="period-buttons-group flex-row gap-2">
					<ng-container *ngIf="activeTab !== tabs.environment">
						<btn-c
							[variant]="period !== periodObj ? 'outlined' : ''"
							*ngFor="let periodObj of dashboardPeriod"
							[isDisabled]="getDataInProcess"
							(action)="changePeriod(periodObj);">
							{{periodObj.display}}
						</btn-c>
					</ng-container>
				</div>
				<div style="position: relative; display: inline-block;"
					 *ngIf="activeTab !== tabs.environment">
					<btn-c endIcon="far fa-filter" variant="outlined" style="width: 140px;"
						[isDisabled]="!mailboxes?.length || getDataInProcess"
						(action)="openUsersFilterPopup();">
						<span *ngIf="!activeSpecificUsers">Filter Users</span>
						<span *ngIf="activeSpecificUsers">
							{{activeSpecificUsers.length}} User{{activeSpecificUsers.length === 1 ? '' : 's'}} selected
						</span>
					</btn-c>
					<span *ngIf="activeSpecificUsers"
						  style="position: absolute; top: -4px; right: 2px; width: 10px; height: 10px; border-radius: 50%; background: #8be052; border: 2px solid #0d1117;">
					</span>
				</div>
			</div>

			<!-- ==================== ENVIRONMENT TAB ==================== -->
			<div class="bs-enabled mt-3 animated fadeIn" *ngIf="activeTab === tabs.environment" id="envTabContainer">
				<div class="bs-container w-100" style="max-width: none !important;">

					<!-- Environment KPI Cards -->
					<div class="kpi-row kpi-row-4">
						<div class="kpi-card" *ngFor="let card of envKpiCards">
							<div class="kpi-icon" [ngStyle]="{'background': card.color + '18', 'color': card.color}">
								<i [ngClass]="card.icon"></i>
							</div>
							<div class="kpi-body position-relative">
								<div class="kpi-value" *ngIf="!getDataInProcess && !envLoadingResources">{{card.value}}</div>
								<div *ngIf="getDataInProcess || envLoadingResources" class="loading-spinner" style="width: 20px; height: 20px; border-width: 3px; right: 0; left: auto; top: 0;"></div>
								<span>{{card.label}}</span>
							</div>
						</div>
					</div>

					<div class="bs-row g-4">

						<!--Last Scanned Resources-->
						<div class="bs-col-6 bs-col-large-6" style="min-height: 320px;">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1 mb-3">
									<h6 class="m-0 fw-bold text-nowrap">Last Scanned Resources</h6>
									<span class="opacity-75 fw-500 text-start" style="font-size: 12px;">
										Resources most recently scanned for threats and sensitive content
									</span>
								</div>
								<div class="flex-column gap-1 f-1-0 overflow-auto pe-3" *ngIf="!envLoadingResources" style="max-height: 300px;">
									<div class="scan-item flxRow-between align-items-center clickable-row" *ngFor="let res of recentScanResources" (click)="currentResourceInfoObj = res">
										<div class="flxRow gap-2 align-items-center" style="min-width: 0;">
											<i [ngClass]="resourceTypeIcon(res.resource_type)" style="font-size: 12px; color: #486db5; flex-shrink: 0;"></i>
											<span class="fw-500 text-ellipsis" style="font-size: 13px;">{{res.name || 'Unnamed'}}</span>
										</div>
										<span class="opacity-50" style="font-size: 11px; white-space: nowrap;" [tooltip]="res.createdLabel">{{res.relativeTime}}</span>
									</div>
									<div class="flex-column text-center centralize f-1-0" *ngIf="!recentScanResources?.length">
										<span class="fw-500 opacity-75">No scan activity yet</span>
									</div>
								</div>
								<!--tips modal-->
								<div class="trends-card-actions-menu tips"
									 [ngClass]="{'active' : showLastScannedResourcesTips}">
									<i class="far fa-lightbulb" id="lastScannedResourcesTipsTrigger" tooltip="Tips"
									   (click)="showLastScannedResourcesTips = !showLastScannedResourcesTips"></i>
									<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
										 [ngClass]="{'active' : showLastScannedResourcesTips}">
										<ul style="cursor: default;" (clickOutside)="showLastScannedResourcesTips = false;"
											[exclude]="'#lastScannedResourcesTipsTrigger'">
											<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
												<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
												<span class="fw-500">Click a resource name to see more details.</span>
											</div>
										</ul>
									</div>
								</div>
								<div class="flex-column text-center centralize f-1-0" *ngIf="envLoadingResources">
									<loader class="opacity-75 align-self-center" height="100" width="100"></loader>
								</div>
							</div>
						</div>

						<!--Recent Findings-->
						<div class="bs-col-6 bs-col-large-6" style="min-height: 320px;">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1 mb-3">
									<h6 class="m-0 fw-bold text-nowrap">Recent Findings</h6>
									<span class="opacity-75 fw-500 text-start" style="font-size: 12px;">
										Latest threats and sensitive content detected across all resources
									</span>
								</div>
								<div class="flex-column gap-1 f-1-0 overflow-auto pe-3" *ngIf="!getDataInProcess" style="max-height: 300px;">
									<div class="scan-item flxRow-between align-items-center clickable-row"
										 *ngFor="let assetObj of trendsInfo?.recentFindings"
										 (click)="currentAssetInfoObj = assetObj;">
										<div class="flxRow gap-2 align-items-center" style="min-width: 0; flex: 1;">
											<i style="font-size: 11px; flex-shrink: 0;"
											   [ngClass]="assetObj.malicious_info ? 'far fa-bug' : 'fas fa-shield-alt'"
											   [ngStyle]="{'color': assetObj.malicious_info ? '#D92D20' : '#D97706'}"></i>
											<div class="flex-column" style="min-width: 0;">
												<span class="fw-500 text-ellipsis" style="font-size: 12px;">{{assetObj.resource_id?.name}}</span>
												<span class="opacity-50 text-ellipsis" style="font-size: 11px;">{{assetObj.user}} &middot; {{assetObj.asset_type | titlecase}}</span>
											</div>
										</div>
										<div class="flex-row align-items-center gap-2">
											<div class="flex-row gap-1 align-items-center" *ngIf="assetObj.resource_id">
												<span class="resource-type-chip">
													<i class="far" [ngClass]="{
														'fa-hashtag': assetObj.resource_id?.resource_type === 'channel',
														'fa-comments': assetObj.resource_id?.resource_type === 'chat',
														'fa-video': assetObj.resource_id?.resource_type === 'meeting',
														'fa-globe': assetObj.resource_id?.resource_type === 'site',
														'fa-cloud': assetObj.resource_id?.resource_type === 'OneDrive'
													}"></i>
													{{assetObj.resource_id?.resource_type || 'N/A'}}
												</span>
												<span class="resource-type-chip" *ngIf="assetObj.resource_id?.resource_sub_type && assetObj.resource_id?.resource_sub_type !== assetObj.resource_id?.resource_type">
													<i class="far" [ngClass]="{
														'fa-globe': assetObj.resource_id?.resource_sub_type === 'site',
														'fa-hashtag': assetObj.resource_id?.resource_sub_type === 'channel',
														'fa-user': assetObj.resource_id?.resource_sub_type === 'personal'
													}"></i>
													{{assetObj.resource_id?.resource_sub_type}}
												</span>
											</div>


											<span class="opacity-50" style="font-size: 11px; white-space: nowrap;" [tooltip]="assetObj.createdLabel">{{assetObj.relativeTime}}</span>
										</div>
									</div>
									<div class="flex-column text-center centralize f-1-0" *ngIf="!trendsInfo?.recentFindings?.length">
										<span class="fw-500 opacity-75">No findings yet</span>
									</div>
								</div>
								<!--tips modal-->
								<div class="trends-card-actions-menu tips"
									 [ngClass]="{'active' : showRecentFindingsTips}">
									<i class="far fa-lightbulb" id="recentFindingsTipsTrigger" tooltip="Tips"
									   (click)="showRecentFindingsTips = !showRecentFindingsTips"></i>
									<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
										 [ngClass]="{'active' : showRecentFindingsTips}">
										<ul style="cursor: default;" (clickOutside)="showRecentFindingsTips = false;"
											[exclude]="'#recentFindingsTipsTrigger'">
											<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
												<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
												<span class="fw-500">Click on an item to see more details.</span>
											</div>
										</ul>
									</div>
								</div>
								<div class="flex-column text-center centralize f-1-0" *ngIf="getDataInProcess">
									<loader class="opacity-75 align-self-center" height="100" width="100"></loader>
								</div>
							</div>
						</div>

						<!--Resource Breakdown-->
						<div class="bs-col-6 bs-col-large-6" style="min-height: 320px;">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1 mb-3">
									<h6 class="m-0 fw-bold text-nowrap">Resource Breakdown</h6>
									<span class="opacity-75 fw-500 text-start" style="font-size: 12px;">
										Distribution of monitored collaboration resources by type
									</span>
								</div>
								<div class="flex-column gap-2 f-1-0" *ngIf="!envLoadingResources">
									<div class="env-resource-row flxRow-between align-items-center cursor-pointer"
										 *ngFor="let entry of resourcesByType | keyvalue: gs.returnZero"
										 (click)="goToResources({filters: [{key: 'type', option: entry.key, newValue: true}]})"
										 [tooltip]="resourceTypeTooltip[entry.key]" placement="right">
										<div class="flxRow gap-2 align-items-center">
											<div class="env-resource-icon">
												<i [ngClass]="resourceTypeIcon(entry.key)"></i>
											</div>
											<span class="fw-500">{{resourceTypeLabel(entry.key)}}</span>
										</div>
										<span class="env-resource-count">{{entry.value.length}}</span>
									</div>
									<div class="flex-column text-center centralize f-1-0" *ngIf="!(resourcesByType | keyvalue)?.length">
										<span class="fw-500 opacity-75">No resources discovered yet</span>
									</div>
								</div>
								<!--tips modal-->
								<div class="trends-card-actions-menu tips"
									 [ngClass]="{'active' : showResourceBreakdownTips}">
									<i class="far fa-lightbulb" id="resourceBreakdownTipsTrigger" tooltip="Tips"
									   (click)="showResourceBreakdownTips = !showResourceBreakdownTips"></i>
									<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
										 [ngClass]="{'active' : showResourceBreakdownTips}">
										<ul style="cursor: default;" (clickOutside)="showResourceBreakdownTips = false;"
											[exclude]="'#resourceBreakdownTipsTrigger'">
											<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
												<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
												<span class="fw-500">Click a resource type to view its resources.</span>
											</div>
										</ul>
									</div>
								</div>
								<div class="flex-column text-center centralize f-1-0" *ngIf="envLoadingResources">
									<loader class="opacity-75 align-self-center" height="100" width="100"></loader>
								</div>
							</div>
						</div>

						<!--Protected Users-->
						<div class="bs-col-6 bs-col-large-6" style="min-height: 320px;">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1 mb-3">
									<div class="flxRow-between align-items-center w-100">
										<h6 class="m-0 fw-bold text-nowrap">Protected Users</h6>
										<span class="fw-500 opacity-75" style="font-size: 12px;" *ngIf="!envLoadingUsers">{{envKpiCards[0].value}} mailboxes</span>
									</div>
									<span class="opacity-75 fw-500 text-start" style="font-size: 12px;">
										Mailboxes currently monitored by collaboration protection
									</span>
								</div>
								<div class="flex-column gap-1 f-1-0 overflow-auto pe-3" *ngIf="!envLoadingUsers" style="max-height: 300px;">
									<div class="user-item flxRow-between align-items-center" *ngFor="let user of mailboxes; let i = index">
										<div class="flxRow gap-2 align-items-center" style="min-width: 0;">
											<span class="user-rank">{{i + 1}}</span>
											<span class="user-email text-ellipsis">{{user.email}}</span>
										</div>
										<span class="status-badge badge-active" *ngIf="user.is_protected">Protected</span>
										<span class="status-badge badge-inactive" *ngIf="!user.is_protected">Unprotected</span>
									</div>
									<div class="flex-column text-center centralize f-1-0" *ngIf="!mailboxes?.length">
										<span class="fw-500 opacity-75">No users configured yet</span>
									</div>
								</div>
								<div class="flex-column text-center centralize f-1-0" *ngIf="envLoadingUsers">
									<loader class="opacity-75 align-self-center" height="100" width="100"></loader>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>

			<!-- ==================== DLP TAB ==================== -->
			<div class="bs-enabled mt-3 animated fadeIn" *ngIf="activeTab === tabs.dlp" id="dlpTabContainer">
				<div class="bs-container w-100" style="max-width: none !important;">
					<div class="bs-row g-4">

						<!-- DLP KPI Cards -->
						<div class="bs-col-12">
							<div class="kpi-row">
								<div class="kpi-card" *ngFor="let card of dlpKpiCards">
									<div class="kpi-icon" [ngStyle]="{'background': card.color + '18', 'color': card.color}">
										<i [ngClass]="card.icon"></i>
									</div>
									<div class="kpi-body position-relative">
										<div class="kpi-value" *ngIf="!getDataInProcess">{{card.value}}</div>
										<div *ngIf="getDataInProcess" class="loading-spinner" style="width: 20px; height: 20px; border-width: 3px; right: 0; left: auto; top: 0;"></div>
										<span>{{card.label}}</span>
									</div>
								</div>
							</div>
						</div>

						<!--DLP activity-->
						<div class="bs-col-6 bs-col-large-4" style="height: clamp(350px,50vh,405px);">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1">
									<div class="flex-row align-items-center gap-1">
										<h6 class="m-0 fw-bold text-nowrap">Sensitive Data Activity</h6>
									</div>
									<span class="opacity-75 fw-500 text-start" style="height: 16px;">
										Distribution of sensitive data activity found in collaboration resources
									</span>
								</div>
								<div class="flex-column f-1-0 animated fadeIn" *ngIf="trendsInfo?.dlpBySource?.total">
									<apx-chart class="f-1-0 animated fadeIn clickable-chart"
											   *ngIf="dlpTrendsChart?.xaxis?.categories?.length && !getDataInProcess"
											   #dlpTrends
											   [series]="dlpTrendsChart.series"
											   [chart]="dlpTrendsChart.chart"
											   [plotOptions]="dlpTrendsChart.plotOptions"
											   [colors]="dlpTrendsChart.colors"
											   [stroke]="dlpTrendsChart.stroke"
											   [xaxis]="dlpTrendsChart.xaxis"
											   [yaxis]="dlpTrendsChart.yaxis"
											   [fill]="dlpTrendsChart.fill"
											   [dataLabels]="dlpTrendsChart.dataLabels"></apx-chart>
								</div>
								<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsInfo?.dlpBySource?.total || getDataInProcess">
									<div class="flex-column text-center centralize f-1-0">
										<span class="fw-500 opacity-75" *ngIf="!getDataInProcess">No data for selected time period</span>
										<loader class="opacity-75 align-self-center" *ngIf="getDataInProcess" height="100" width="100"></loader>
									</div>
								</div>
							</div>
						</div>

						<!--Classification Types-->
						<div class="bs-col-6 bs-col-large-4" style="height: clamp(350px,50vh,405px);">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1">
									<div class="flex-row align-items-center gap-1">
										<h6 class="m-0 fw-bold text-nowrap">Sensitive Data Types</h6>
									</div>
									<span class="opacity-75 fw-500 text-start" style="height: 16px;">
										Most commonly detected sensitive data types
									</span>
								</div>
								<div class="flex-column f-1-0 centralize animated fadeIn">
									<apx-chart class="pie-chart pie-chart-left" style="width: 100%; height: 100%;"
											   *ngIf="dlpClassificationChart?.series?.length && !getDataInProcess"
											   #classificationTypesChart
											   [series]="dlpClassificationChart.series"
											   [chart]="dlpClassificationChart.chart"
											   [plotOptions]="dlpClassificationChart.plotOptions"
											   [dataLabels]="dlpClassificationChart.dataLabels"
											   [colors]="dlpClassificationChart.colors"
											   [labels]="dlpClassificationChart.labels"></apx-chart>
								</div>
								<!--tips modal-->
								<div class="trends-card-actions-menu tips"
									 [ngClass]="{'active' : showDlpSensitivityTypesTips}">
									<i class="far fa-lightbulb" id="dlpSensitivityTypesTipsTrigger" tooltip="Tips"
									   (click)="showDlpSensitivityTypesTips = !showDlpSensitivityTypesTips"></i>
									<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
										 [ngClass]="{'active' : showDlpSensitivityTypesTips}">
										<ul style="cursor: default;" (clickOutside)="showDlpSensitivityTypesTips = false;"
											[exclude]="'#dlpSensitivityTypesTipsTrigger'">
											<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
												<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
												<span class="fw-500">Click a segment to view related assets.</span>
											</div>
										</ul>
									</div>
								</div>
								<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsInfo?.dlpBySource?.total || getDataInProcess">
									<div class="flex-column text-center centralize f-1-0">
										<span class="fw-500 opacity-75" *ngIf="!getDataInProcess">No data for selected time period</span>
										<loader class="opacity-75 align-self-center" *ngIf="getDataInProcess" height="100" width="100"></loader>
									</div>
								</div>
							</div>
						</div>

						<!--DLP source-->
						<div class="bs-col-6 bs-col-large-4" style="height: clamp(350px,50vh,405px);">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1">
									<div class="flex-row align-items-center gap-1">
										<h6 class="m-0 fw-bold text-nowrap">Sensitive Data Findings by Source</h6>
									</div>
									<span class="opacity-75 fw-500 text-start" style="height: 16px;">
										Distribution of sensitive data activity found by collaboration resource
									</span>
								</div>
								<div class="flex-column f-1-0 centralize animated fadeIn">
									<apx-chart class="pie-chart animated fadeIn clickable-chart" style="width: 100%; max-width: 400px;"
											   *ngIf="trendsInfo?.dlpBySource?.total && !getDataInProcess"
											   #dlpSourcePie
											   [series]="dlpSourcePieChart.series"
											   [chart]="dlpSourcePieChart.chart"
											   [plotOptions]="dlpSourcePieChart.plotOptions"
											   [dataLabels]="dlpSourcePieChart.dataLabels"
											   [colors]="dlpSourcePieChart.colors"
											   [labels]="dlpSourcePieChart.labels"></apx-chart>
								</div>
								<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsInfo?.dlpBySource?.total || getDataInProcess">
									<div class="flex-column text-center centralize f-1-0">
										<span class="fw-500 opacity-75" *ngIf="!getDataInProcess">No data for selected time period</span>
										<loader class="opacity-75 align-self-center" *ngIf="getDataInProcess" height="100" width="100"></loader>
									</div>
								</div>
							</div>
						</div>

						<!--External Exposure-->
						<div class="bs-col-6 bs-col-large-4" style="height: clamp(350px,50vh,405px);">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1">
									<h6 class="m-0 fw-bold text-nowrap">Externally Shared Sensitive Data</h6>
									<span class="opacity-75 fw-500 text-start" style="height: 16px;">
										Sensitive data in resources accessible to external users
									</span>
								</div>
								<div style="margin-top: 5px; overflow: auto; flex: 1 0;">
									<div class="user-list flxClmn gap-2" *ngIf="!getDataInProcess && trendsInfo?.externalExposure?.length">
										<div class="user-item flxRow-between align-items-center clickable-row"
											 *ngFor="let res of trendsInfo.externalExposure; let i = index"
											 (click)="currentAssetInfoObj = res;">
											<div class="flxRow gap-2 align-items-center" style="min-width: 0;">
												<span class="user-rank">{{i + 1}}</span>
												<i [ngClass]="resourceTypeIcon(res.resource_id?.resource_type)" style="font-size: 12px; color: #64748b; flex-shrink: 0;"></i>
												<span class="user-email text-ellipsis">{{res.file_name || res.sensitivity_info?.fileName || res.resource_id?.name}}</span>
											</div>
										</div>
									</div>
								</div>
								<!--tips modal-->
								<div class="trends-card-actions-menu tips"
									 [ngClass]="{'active' : showExternalSharedDataTips}">
									<i class="far fa-lightbulb" id="externalSharedDataTipsTrigger" tooltip="Tips"
									   (click)="showExternalSharedDataTips = !showExternalSharedDataTips"></i>
									<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
										 [ngClass]="{'active' : showExternalSharedDataTips}">
										<ul style="cursor: default;" (clickOutside)="showExternalSharedDataTips = false;"
											[exclude]="'#externalSharedDataTipsTrigger'">
											<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
												<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
												<span class="fw-500">Click on a resource name to see more details.</span>
											</div>
										</ul>
									</div>
								</div>
								<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsInfo?.externalExposure?.length || getDataInProcess">
									<div class="flex-column text-center centralize f-1-0">
										<span class="fw-500 opacity-75" *ngIf="!getDataInProcess">No externally exposed sensitive data</span>
										<loader class="opacity-75 align-self-center" *ngIf="getDataInProcess" height="100" width="100"></loader>
									</div>
								</div>
							</div>
						</div>

						<!--Top Sensitive Data Resources-->
						<div class="bs-col-6 bs-col-large-4" style="height: clamp(350px,50vh,405px);">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1">
									<div class="flex-row align-items-center gap-1">
										<h6 class="m-0 fw-bold text-nowrap">Top Sensitive Data Resources</h6>
									</div>
									<span class="opacity-75 fw-500 text-start" style="height: 16px;">
										Collaboration resources that generated the most sensitive data activity
									</span>
								</div>
								<div style="margin-top: 5px;">
									<div class="user-list flxClmn gap-2" *ngIf="!getDataInProcess">
										<div class="user-item flxRow-between align-items-center clickable-row" *ngFor="let res of trendsInfo?.topDlpResources; let i = index"
											 (click)="showResourceAssets(res, 'DLP')">
											<div class="flxRow gap-2 align-items-center" style="min-width: 0;">
												<span class="user-rank">{{i + 1}}</span>
												<span class="resource-type-chip">
												<i class="far" [ngClass]="{
													'fa-hashtag': res.resource_id?.resource_type === 'channel',
													'fa-comments': res.resource_id?.resource_type === 'chat',
													'fa-video': res.resource_id?.resource_type === 'meeting',
													'fa-globe': res.resource_id?.resource_type === 'site',
													'fa-cloud': res.resource_id?.resource_type === 'OneDrive'
												}"></i>
													{{res.resource_id?.resource_type || 'N/A'}}
												</span>

												<span class="resource-type-chip" *ngIf="res.resource_id?.resource_sub_type && res.resource_id?.resource_sub_type !== res.resource_id?.resource_type">
													<i class="far" [ngClass]="{
														'fa-globe': res.resource_id?.resource_sub_type === 'site',
														'fa-hashtag': res.resource_id?.resource_sub_type === 'channel',
														'fa-user': res.resource_id?.resource_sub_type === 'personal'
													}"></i>
													{{res.resource_id?.resource_sub_type}}
												</span>
												<span class="user-email text-ellipsis">{{res.name}}</span>
											</div>
											<span class="user-hits" [class.hits-high]="res.hits >= 10" [class.hits-medium]="res.hits >= 5 && res.hits < 10">
												{{res.hits}} findings
											</span>
										</div>
									</div>
								</div>
								<!--tips modal-->
								<div class="trends-card-actions-menu tips"
									 [ngClass]="{'active' : showSensitiveDataResourcesTips}">
									<i class="far fa-lightbulb" id="sensitiveDataResourcesTipsTrigger" tooltip="Tips"
									   (click)="showSensitiveDataResourcesTips = !showSensitiveDataResourcesTips"></i>
									<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
										 [ngClass]="{'active' : showSensitiveDataResourcesTips}">
										<ul style="cursor: default;" (clickOutside)="showSensitiveDataResourcesTips = false;"
											[exclude]="'#sensitiveDataResourcesTipsTrigger'">
											<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
												<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
												<span class="fw-500">Click on an item to see more details.</span>
											</div>
										</ul>
									</div>
								</div>
								<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsInfo?.dlpBySource?.total || getDataInProcess">
									<div class="flex-column text-center centralize f-1-0">
										<span class="fw-500 opacity-75" *ngIf="!getDataInProcess">No data for selected time period</span>
										<loader class="opacity-75 align-self-center" *ngIf="getDataInProcess" height="100" width="100"></loader>
									</div>
								</div>
							</div>
						</div>

						<!--Top DLP Users-->
						<div class="bs-col-6 bs-col-large-4" style="height: clamp(350px,50vh,405px);">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1">
									<div class="flex-row align-items-center gap-1">
										<h6 class="m-0 fw-bold text-nowrap">Top Sensitive Data Users</h6>
									</div>
									<span class="opacity-75 fw-500 text-start" style="height: 16px;">
										Users in your organization with the most sensitive data findings
									</span>
								</div>
								<div style="margin-top: 5px;">
									<div class="user-list flxClmn gap-2" *ngIf="!getDataInProcess">
										<div class="user-item flxRow-between align-items-center cursor-pointer hvr-opacity"
											 (click)="showAssetsPopup(user.email, 'DLP')"
											 *ngFor="let user of trendsInfo?.topDlpUsers; let i = index">
											<div class="flxRow gap-2 align-items-center">
												<span class="user-rank">{{i + 1}}</span>
												<span class="user-email">{{user.email}}</span>
											</div>
											<span class="user-hits" [class.hits-high]="user.hits >= 5" [class.hits-medium]="user.hits >= 3 && user.hits < 5">
												{{user.hits}} findings
											</span>
										</div>
									</div>
								</div>
								<!--tips modal-->
								<div class="trends-card-actions-menu tips"
									 [ngClass]="{'active' : showTopDlpUsersTips}">
									<i class="far fa-lightbulb" id="topDlpUsersTipsTrigger" tooltip="Tips"
									   (click)="showTopDlpUsersTips = !showTopDlpUsersTips"></i>
									<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
										 [ngClass]="{'active' : showTopDlpUsersTips}">
										<ul style="cursor: default;" (clickOutside)="showTopDlpUsersTips = false;"
											[exclude]="'#topDlpUsersTipsTrigger'">
											<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
												<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
												<span class="fw-500">Click a user to view their assets.</span>
											</div>
										</ul>
									</div>
								</div>
								<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsInfo?.dlpBySource?.total || getDataInProcess">
									<div class="flex-column text-center centralize f-1-0">
										<span class="fw-500 opacity-75" *ngIf="!getDataInProcess">No data for selected time period</span>
										<loader class="opacity-75 align-self-center" *ngIf="getDataInProcess" height="100" width="100"></loader>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- ==================== MALICIOUS TAB ==================== -->
			<div class="bs-enabled mt-3 animated fadeIn" *ngIf="activeTab === tabs.malicious" id="maliciousTabContainer">
				<div class="bs-container w-100" style="max-width: none !important;">
					<div class="bs-row g-4">

						<!-- Threat KPI Cards -->
						<div class="bs-col-12">
							<div class="kpi-row">
								<div class="kpi-card" *ngFor="let card of threatKpiCards">
									<div class="kpi-icon" [ngStyle]="{'background': card.color + '18', 'color': card.color}">
										<i [ngClass]="card.icon"></i>
									</div>
									<div class="kpi-body position-relative">
										<div *ngIf="!getDataInProcess" class="kpi-value">{{card.value}}</div>
										<div *ngIf="getDataInProcess" class="loading-spinner" style="width: 20px; height: 20px; border-width: 3px; right: 0; left: auto; top: 0;"></div>
										<span>{{card.label}}</span>
									</div>
								</div>
							</div>
						</div>

						<!--Threat Activity-->
						<div class="bs-col-6 bs-col-large-4" style="height: clamp(350px,50vh,405px);">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1">
									<div class="flex-row align-items-center gap-1">
										<h6 class="m-0 fw-bold text-nowrap">Threat Activity</h6>
									</div>
									<span class="opacity-75 fw-500 text-start" style="height: 16px;">
										Distribution of threats found in collaboration resources
									</span>
								</div>
								<div class="flex-column f-1-0 animated fadeIn">
									<apx-chart class="f-1-0 animated fadeIn clickable-chart"
											   *ngIf="trendsInfo?.threatsBySource?.total && !getDataInProcess"
											   #threatActivityTrends
											   [series]="threatActivityTrendsChart.series"
											   [chart]="threatActivityTrendsChart.chart"
											   [plotOptions]="threatActivityTrendsChart.plotOptions"
											   [colors]="threatActivityTrendsChart.colors"
											   [stroke]="threatActivityTrendsChart.stroke"
											   [xaxis]="threatActivityTrendsChart.xaxis"
											   [yaxis]="threatActivityTrendsChart.yaxis"
											   [fill]="threatActivityTrendsChart.fill"
											   [dataLabels]="threatActivityTrendsChart.dataLabels"></apx-chart>
								</div>
								<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsInfo?.threatsBySource?.total || getDataInProcess">
									<div class="flex-column text-center centralize f-1-0">
										<span class="fw-500 opacity-75" *ngIf="!getDataInProcess">No data for selected time period</span>
										<loader class="opacity-75 align-self-center" *ngIf="getDataInProcess" height="100" width="100"></loader>
									</div>
								</div>
							</div>
						</div>

						<!--Threat Types Breakdown-->
						<div class="bs-col-6 bs-col-large-4" style="height: clamp(350px,50vh,405px);">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1">
									<h6 class="m-0 fw-bold text-nowrap">Threat Types</h6>
									<span class="opacity-75 fw-500 text-start" style="height: 16px;">
										Distribution of detected threats by detection category
									</span>
								</div>
								<div class="flex-column f-1-0 centralize animated fadeIn">
									<apx-chart class="pie-chart animated fadeIn clickable-chart" style="width: 100%; max-width: 400px;"
											   *ngIf="malwareTypesChart?.series?.length && !getDataInProcess"
											   [series]="malwareTypesChart.series"
											   [chart]="malwareTypesChart.chart"
											   [plotOptions]="malwareTypesChart.plotOptions"
											   [dataLabels]="malwareTypesChart.dataLabels"
											   [colors]="malwareTypesChart.colors"
											   [labels]="malwareTypesChart.labels"
											   [tooltip]="malwareTypesChart.tooltip"></apx-chart>
								</div>
								<!--tips modal-->
								<div class="trends-card-actions-menu tips"
									 [ngClass]="{'active' : showThreatTypesTips}">
									<i class="far fa-lightbulb" id="threatTypesTipsTrigger" tooltip="Tips"
									   (click)="showThreatTypesTips = !showThreatTypesTips"></i>
									<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
										 [ngClass]="{'active' : showThreatTypesTips}">
										<ul style="cursor: default;" (clickOutside)="showThreatTypesTips = false;"
											[exclude]="'#threatTypesTipsTrigger'">
											<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
												<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
												<span class="fw-500">Click a segment to view related assets.</span>
											</div>
										</ul>
									</div>
								</div>
								<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!malwareTypesChart?.series?.length || getDataInProcess">
									<div class="flex-column text-center centralize f-1-0">
										<span class="fw-500 opacity-75" *ngIf="!getDataInProcess">No data for selected time period</span>
										<loader class="opacity-75 align-self-center" *ngIf="getDataInProcess" height="100" width="100"></loader>
									</div>
								</div>
							</div>
						</div>

						<!--most affected user-->
						<div class="bs-col-6 bs-col-large-4" style="height: clamp(350px,50vh,405px);">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1">
									<div class="flex-row align-items-center gap-1">
										<h6 class="m-0 fw-bold text-nowrap">Most Affected user</h6>
									</div>
									<span class="opacity-75 fw-500 text-start" style="height: 16px;">
										Users in your organization who were exposed to the most threats
									</span>
								</div>
								<div class="mt-2" *ngIf="trendsInfo?.topTargetedUsers?.length">
									<div class="user-list flxClmn gap-2" *ngIf="!getDataInProcess">
										<div class="user-item flxRow-between align-items-center cursor-pointer hvr-opacity" *ngFor="let user of trendsInfo.topTargetedUsers; let i = index"
											 (click)="showAssetsPopup(user.email, 'Malicious')">
											<div class="flxRow gap-2 align-items-center">
												<span class="user-rank">{{i + 1}}</span>
												<span class="user-email">{{user.email}}</span>
											</div>
											<span class="user-hits" [class.hits-high]="user.hits >= 5" [class.hits-medium]="user.hits >= 3 && user.hits < 5">
												{{user.hits}} hits
											</span>
										</div>
									</div>
								</div>
								<!--tips modal-->
								<div class="trends-card-actions-menu tips"
									 [ngClass]="{'active' : showTopTargetedUsersTips}">
									<i class="far fa-lightbulb" id="topTargetedUsersTipsTrigger" tooltip="Tips"
									   (click)="showTopTargetedUsersTips = !showTopTargetedUsersTips"></i>
									<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
										 [ngClass]="{'active' : showTopTargetedUsersTips}">
										<ul style="cursor: default;" (clickOutside)="showTopTargetedUsersTips = false;"
											[exclude]="'#topTargetedUsersTipsTrigger'">
											<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
												<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
												<span class="fw-500">Click a user to view their assets.</span>
											</div>
										</ul>
									</div>
								</div>
								<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsInfo?.topTargetedUsers?.length || getDataInProcess">
									<div class="flex-column text-center centralize f-1-0">
										<span class="fw-500 opacity-75" *ngIf="!getDataInProcess">No data for selected time period</span>
										<loader class="opacity-75 align-self-center" *ngIf="getDataInProcess" height="100" width="100"></loader>
									</div>
								</div>
							</div>
						</div>

						<!--Threat source-->
						<div class="bs-col-6 bs-col-large-4" style="height: clamp(350px,50vh,405px);">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1">
									<div class="flex-row align-items-center gap-1">
										<h6 class="m-0 fw-bold text-nowrap">Threats by Source</h6>
									</div>
									<span class="opacity-75 fw-500 text-start" style="height: 16px;">
										Distribution of threats found by collaboration resource
									</span>
								</div>
								<div class="flex-column f-1-0 centralize animated fadeIn">
									<apx-chart class="pie-chart animated fadeIn clickable-chart" style="width: 100%; max-width: 400px;"
											   *ngIf="trendsInfo?.threatsBySource?.total && !getDataInProcess"
											   #threatSourcePie
											   [series]="threatSourcePieChart.series"
											   [chart]="threatSourcePieChart.chart"
											   [plotOptions]="threatSourcePieChart.plotOptions"
											   [dataLabels]="threatSourcePieChart.dataLabels"
											   [colors]="threatSourcePieChart.colors"
											   [labels]="threatSourcePieChart.labels"></apx-chart>
								</div>
								<!--tips modal-->
								<div class="trends-card-actions-menu tips"
									 [ngClass]="{'active' : showThreatsBySourceTips}">
									<i class="far fa-lightbulb" id="threatsBySourceTipsTrigger" tooltip="Tips"
									   (click)="showThreatsBySourceTips = !showThreatsBySourceTips"></i>
									<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
										 [ngClass]="{'active' : showThreatsBySourceTips}">
										<ul style="cursor: default;" (clickOutside)="showThreatsBySourceTips = false;"
											[exclude]="'#threatsBySourceTipsTrigger'">
											<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
												<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
												<span class="fw-500">Click a segment to view related assets.</span>
											</div>
										</ul>
									</div>
								</div>
								<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsInfo?.threatsBySource?.total || getDataInProcess">
									<div class="flex-column text-center centralize f-1-0">
										<span class="fw-500 opacity-75" *ngIf="!getDataInProcess">No data for selected time period</span>
										<loader class="opacity-75 align-self-center" *ngIf="getDataInProcess" height="100" width="100"></loader>
									</div>
								</div>
							</div>
						</div>

						<!--Top Targeted Resources-->
						<!--Top Sensitive Data Resources-->
						<div class="bs-col-6 bs-col-large-4" style="height: clamp(350px,50vh,405px);">
							<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
								<div class="flex-column align-items-start gap-1">
									<div class="flex-row align-items-center gap-1">
										<h6 class="m-0 fw-bold text-nowrap">Top Targeted Resources
										</h6>
									</div>
									<span class="opacity-75 fw-500 text-start" style="height: 16px;">
										Resources that received the most malicious content
									</span>
								</div>
								<div style="margin-top: 5px;">
									<div class="user-list flxClmn gap-2" *ngIf="!getDataInProcess">
										<div class="user-item flxRow-between align-items-center clickable-row" *ngFor="let res of trendsInfo?.topMaliciousResources; let i = index"
											 (click)="showResourceAssets(res, 'Malicious')">
											<div class="flxRow gap-2 align-items-center" style="min-width: 0;">
												<span class="user-rank">{{i + 1}}</span>
												<span class="resource-type-chip">
													<i class="far" [ngClass]="{
														'fa-hashtag': res.resource_id?.resource_type === 'channel',
														'fa-comments': res.resource_id?.resource_type === 'chat',
														'fa-video': res.resource_id?.resource_type === 'meeting',
														'fa-globe': res.resource_id?.resource_type === 'site',
														'fa-cloud': res.resource_id?.resource_type === 'OneDrive'
													}"></i>
													{{res.resource_id?.resource_type || 'N/A'}}
												</span>
												<span class="resource-type-chip" *ngIf="res.resource_id?.resource_sub_type && res.resource_id?.resource_sub_type !== res.resource_id?.resource_type">
													<i class="far" [ngClass]="{
														'fa-globe': res.resource_id?.resource_sub_type === 'site',
														'fa-hashtag': res.resource_id?.resource_sub_type === 'channel',
														'fa-user': res.resource_id?.resource_sub_type === 'personal'
													}"></i>
													{{res.resource_id?.resource_sub_type}}
												</span>
												<span class="user-email text-ellipsis">{{res.name}}</span>
											</div>
											<span class="user-hits" [class.hits-high]="res.hits >= 10" [class.hits-medium]="res.hits >= 5 && res.hits < 10">
												{{res.hits}} findings
											</span>
										</div>
									</div>
								</div>
								<!--tips modal-->
								<div class="trends-card-actions-menu tips"
									 [ngClass]="{'active' : showTopTargetedResourcesTips}">
									<i class="far fa-lightbulb" id="topTargetedResourcesTipsTrigger" tooltip="Tips"
									   (click)="showTopTargetedResourcesTips = !showTopTargetedResourcesTips"></i>
									<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
										 [ngClass]="{'active' : showTopTargetedResourcesTips}">
										<ul style="cursor: default;" (clickOutside)="showTopTargetedResourcesTips = false;"
											[exclude]="'#topTargetedResourcesTipsTrigger'">
											<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
												<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
												<span class="fw-500">Click a resource name to see more details.</span>
											</div>
										</ul>
									</div>
								</div>
								<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsInfo?.topMaliciousResources?.length || getDataInProcess">
									<div class="flex-column text-center centralize f-1-0">
										<span class="fw-500 opacity-75" *ngIf="!getDataInProcess">No data for selected time period</span>
										<loader class="opacity-75 align-self-center" *ngIf="getDataInProcess" height="100" width="100"></loader>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<collaboration-asset-info
	*ngIf="currentAssetInfoObj"
	[asset]="currentAssetInfoObj"
	(closeCb)="currentAssetInfoObj = null;">
</collaboration-asset-info>

<collaboration-resource-info
	*ngIf="currentResourceInfoObj"
	[resource]="currentResourceInfoObj"
	(closeCb)="currentResourceInfoObj = null;">
</collaboration-resource-info>

<!--select users popup-->
<popup-c class="bs-enabled" *ngIf="usersPopup?.show"
	head="Show Collaboration Protection Information for Selected Users" size="medium"
	(closeCb)="usersPopup.show = false;"
	(confirmCb)="applyUsersFilter()"
	[buttons]="{cancel: 'Cancel', confirm: 'Confirm'}">
	<div class="flxClmn gap-3 f-1-0" style="overflow: auto;">
		<span>Select one or more users to display Collaboration Protection information for:</span>
		<div class="flxClmn f-1-0 gap-2" style="overflow: auto;">
			<label class="radio-container m-0" style="display: block;">
				All users
				<input type="radio"
					[(ngModel)]="usersPopup.type"
					[value]="usersFilterTypes.all">
				<span class="checkmark"></span>
			</label>
			<div class="flex-row gap-1 align-items-center">
				<label class="radio-container m-0" style="display: block; width: fit-content;">
					Specific users:
					<input type="radio"
						[(ngModel)]="usersPopup.type"
						[value]="usersFilterTypes.specific">
					<span class="checkmark"></span>
				</label>
			</div>
			<div class="position-relative f-1-0 flex-column overflow-auto">
				<div class="w-100 h-100" style="background-color: white; position: absolute; top: 0; left: 0; z-index: 20; opacity: 0.4;"
					*ngIf="usersPopup.type === usersFilterTypes.all">
				</div>
				<trustifi-table-c
					class="trustifi-table f-1-0" style="z-index: 5;"
					[list]="usersPopup.users"
					[headers]="[
						{text:'Email', sortKey: 'email'},
						{text:'Name', sortKey: 'name'},
					]"
					[cellsPrototype]="[
						{textKey: 'email'},
						{textKey: 'name'}
					]"
					(searchFunction)="searchUser($event.searchTerm)"
					[options]="{
						itemsNameSingular: 'user',
						showRadioButtons: true,
						showCounter: true
					}"
				>
				</trustifi-table-c>
			</div>
		</div>
	</div>
</popup-c>

<popup-c class="bs-enabled" *ngIf="generateReportPopup?.show"
		 head="Collaboration Protection Report" size="medium"
		 subTitle="Detailed report of your collaboration environment"
		 (closeCb)="generateReportPopup = null;">
	<div class="flex-column gap-5 f-1-0">
		<!--Schedule Report-->
		<div class="flex-row">
			<div class="flex-column gap-2" style="flex-basis: 250px; flex-shrink: 0; margin-right: 20px;">
				<span style="font-weight: bold;">Schedule report:</span>
				<span class="lh-base" style="font-size: 0.9em;">Scheduled automatic reports that will be sent to reviewers on a daily, weekly, or monthly basis.</span>
			</div>
			<div class="flex-column gap-3 w-100">
				<div *ngFor="let period of ['daily','weekly','monthly']" class="flxRow-start w100 gap-2" style="align-items: center;">
					<div class="flxRow gap-2" style="white-space: nowrap; align-items: center; flex-basis: 165px; flex-shrink: 0;">
						<toggle-switch-c id="{{period}}ReportToggle"
										 [hideText]="true"
										 [(model)]="config.collaboration_protection.scheduled_reports[period].value"
										 (onChange)="generateReportPopup.updateReportSettings()"></toggle-switch-c>
						<span style="vertical-align: middle; text-transform: capitalize;">{{period}} report</span>
					</div>
					<div class="flxRow" style="flex-direction: column;">
						<span [ngClass]="{'text-success' : config.collaboration_protection.scheduled_reports[period]?.value}">Report will be sent {{period === 'daily' ? 'each day' : period === 'weekly' ? 'each Monday' : period === "monthly" ? 'on the 1st of each month' : ''}}.</span>
						<span *ngIf="config.collaboration_protection.scheduled_reports[period].last_report" style="color: green;">(Last report: {{config.collaboration_protection.scheduled_reports[period].last_report | date:'MM/dd/yyyy HH:mm'}})</span>
					</div>
				</div>
			</div>
		</div>

		<div class="flex-row">
			<div class="flex-column gap-2" style="flex-basis: 250px; flex-shrink: 0; margin-right: 20px;">
				<span style="font-weight: bold;">Schedule report extra recipients (Optional)</span>
				<span class="lh-base" style="font-size: 0.9em;">Add the specific addresses to which you would like the report to be sent, in addition to reviewers.</span>
			</div>
			<div class="content-container flex-column gap-2" style="flex: 5 0;">
				<div class="flex-row gap-1">
					<input type="text" style="width: 300px; margin: 0;"
						   placeholder="Email address"
						   (keyup.enter)="addReportAddress(generateReportPopup.reportAddress);"
						   [(ngModel)]="generateReportPopup.reportAddress">
					<btn-c style="min-width: 0;"
						   [endIcon]="'zmdi zmdi-check'"
						   [isDisabled]="generateReportPopup.inProcess || !generateReportPopup.reportAddress"
						   (action)="addReportAddress(generateReportPopup.reportAddress);">
					</btn-c>
				</div>

				<div class="flex-column overflow-auto" style="max-width: fit-content; padding-right: 8px; height: 100px; max-height: 96px;">
					<div *ngFor="let address of config.collaboration_protection.scheduled_reports.addresses; trackBy: gs.trackByIndex">
						<div class="name ellipsis"
							 style="display: inline-block; width: 310px;">{{address}}</div>
						<a class="closeRed action"
						   (click)="deleteReportAddress(address)"
						   [ngClass]="generateReportPopup.inProcess ? 'closeRed disableAction' : 'approveGreen'">
							<i class="far fa-times"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!--Download report-->
		<hr/>
		<div class="flxRow hSpace1" style="align-items: center;">
			<span style="font-weight: bold; margin-right: 20px; flex-basis: 250px; flex-shrink: 0;">Generate now:</span>
			<div class="flxRow hSpace1" style="align-items: center; margin-left: 0;">
				<date-picker-c class="f-1-0" style="min-width: 220px;"
							   [(dateModel)]="generateReportPopup.range"
							   [isRange]="true"
							   [openSelectorTopOfInput]="true"
							   [dateFormat]="'mm/dd/yyyy'">
				</date-picker-c>
			</div>

			<btn-c [isDisabled]="generateReportPopup.inProcess"
				   (click)="generateReportPopup.getReport();">
				Create
			</btn-c>
		</div>
	</div>
</popup-c>


<popup-c *ngIf="currentAssetsPopup?.show"
		 head="Assets of {{currentAssetsPopup.name}}"
		 class="bs-enabled"
		 width="1400px"
		 (closeCb)="currentAssetsPopup = null;"
		 size="large">

	<div class="f-1-0 h100 w100 flxClmn" style="overflow: auto;">
		<trustifi-table-c
			class="trustifi-table" style="flex: 1 0; z-index: 5;"
			[list]="currentAssetsPopup.assets"
			[headers]="[
				{text: 'Detected', sortKey: 'created', width: '110px'},
				{text: 'Resource', sortKey: 'resource_id.name', width: '20%'},
				{text: 'Type', sortKey: 'asset_type', width: '90px'},
				{text: 'Category', sortKey: 'category', width: '115px'},
				{text: 'Detection Details'},
				{text: 'Access', width: '130px'},
			]"
			[cellsPrototype]="[
				{html: 'createdCell'},
				{html: 'resourceCell'},
				{html: 'typeCell'},
				{html: 'categoryCell'},
				{html: 'detectionCell'},
				{html: 'accessCell'},
			]"
			[cellActions]="{
				enable: true,
				selectItemActionCb: selectAssetActionInPopup,
				initActionsFunction: showAssetActionsInPopup
			}"
			[options]="{
				itemsNameSingular: 'asset',
				defaultSortKey: '-created',
			}"
		>
			<ng-template #customCells let-item let-cellId="cellId">

				<!--Detected date-->
				<span *ngIf="cellId === 'createdCell'"
					  style="white-space: normal; text-overflow: unset; text-align: center; display: block; max-width: min-content;">
					{{item.created | date:'MM/dd/yyyy HH:mm'}}
				</span>

				<!--Resource: name + source type chip-->
				<div class="flex-column gap-1" *ngIf="cellId === 'resourceCell'">
					<span class="ellipsis">{{item.resource_id?.name || 'N/A'}}</span>
					<div class="flex-row gap-1 align-items-center">
						<span class="resource-type-chip">
							<i class="far" [ngClass]="{
								'fa-hashtag': item.resource_id?.resource_type === 'channel',
								'fa-comments': item.resource_id?.resource_type === 'chat',
								'fa-video': item.resource_id?.resource_type === 'meeting',
								'fa-globe': item.resource_id?.resource_type === 'site',
								'fa-cloud': item.resource_id?.resource_type === 'OneDrive'
							}"></i>
							{{item.resource_id?.resource_type || 'N/A'}}
						</span>
					</div>
				</div>

				<!--Type: file/message with icon-->
				<div class="flex-column gap-1" *ngIf="cellId === 'typeCell'">
					<div class="flex-row gap-1 align-items-center">
						<i class="far" style="font-size: 11px; color: #64748b;" [ngClass]="{
							'fa-file-alt': item.asset_type === 'file',
							'fa-comment-alt': item.asset_type === 'message'
						}"></i>
						<span>{{item.asset_type | titlecase}}</span>
					</div>
					<span *ngIf="item.asset_type === 'file' && item.size" style="font-size: 11px; color: #64748b;">{{item.size | FormatBytes}}</span>
				</div>

				<!--Category: colored badge for DLP or Malicious-->
				<div *ngIf="cellId === 'categoryCell'">
					<div class="category-badge category-dlp" *ngIf="item.category === 'DLP'">
						<i class="fas fa-shield-alt"></i>
						<span>DLP</span>
						<span class="sensitivity-score-badge"
							  [ngStyle]="{'background': sensitivityScoreColor(item.sensitivity_info?.score)}">
							{{item.sensitivity_info?.score}}
						</span>
					</div>
					<div class="category-badge category-malicious" *ngIf="item.category === 'Malicious'">
						<i class="far fa-bug"></i>
						<span>{{item.malicious_info?.status}}</span>
					</div>
					<div class="category-badge category-rules" *ngIf="item.category === 'Rule'"
						 [tooltip]="item.info?.rule_name ? 'Rule: ' + item.info?.rule_name : null">
						<i class="far fa-list"></i>
						<span style="text-decoration: underline; text-decoration-style: dotted;">Rules</span>
					</div>
				</div>

				<!--Detection Details: sensitive types or malicious sub-category-->
				<div *ngIf="cellId === 'detectionCell'" class="flex-column gap-1">
					<ng-container *ngIf="item.category === 'DLP'">
						<div class="flex-row gap-1 flex-wrap justify-content-start">
							<span class="detection-tag detection-tag-dlp" *ngFor="let type of item._topSensitiveTypes">
								{{type}}
							</span>
						</div>
						<span class="opacity-50" style="font-size: 11px;" *ngIf="item.sensitivity_info.sensitive_types?.length > 3">
							+{{item.sensitivity_info.sensitive_types.length - 3}} more
						</span>
					</ng-container>
					<ng-container *ngIf="item.category === 'Malicious'">
						<div class="flex-column gap-1">
							<div class="flex-row gap-1 flex-wrap justify-content-start" *ngIf="item._maliciousSubCategory?.length">
								<span class="detection-tag detection-tag-malicious" *ngFor="let msg of item._maliciousSubCategory">
									{{msg}}
								</span>
							</div>
							<span class="opacity-75 ellipsis" style="font-size: 11px;" *ngIf="item.malicious_info?.domain"
								  tooltip="{{item.malicious_info?.url}}" placement="top">
								{{item.malicious_info?.domain}}
							</span>
						</div>
					</ng-container>
					<ng-container *ngIf="item.category === 'Rule'">
						<span *ngIf="item.info?.rule_name">
							Rule: {{item.info.rule_name}}
						</span>
					</ng-container>
				</div>

				<!--Access: members count + permission scope-->
				<div *ngIf="cellId === 'accessCell'" class="flex-column gap-1">
					<div class="flex-row gap-1 align-items-center" *ngIf="item.resource_id?.members?.length"
						 tooltip="{{item.resource_id?.members?.join('')}}" placement="top">
						<i class="far fa-users" style="font-size: 10px; color: #64748b;"></i>
						<span class="members-hover-link" style="font-size: 12px;">{{item.resource_id?.members?.length}} member{{item.resource_id?.members?.length !== 1 ? 's' : ''}}</span>
						<span class="external-badge" *ngIf="item.resource_id?.external_members?.length"
							  tooltip="{{item.resource_id?.external_members?.join('')}}" placement="top">
							{{item.resource_id?.external_members?.length}} ext
						</span>
					</div>
					<div class="flex-row gap-1 align-items-center" *ngIf="item.permissions?.link?.scope"
						 (click)="$event.stopPropagation();">
						<i class="far fa-exclamation-triangle text-warning" style="font-size: 10px;"
						   *ngIf="item.permissions?.link?.scope === 'anonymous'"
						   tooltip="This file is publicly accessible">
						</i>
						<span class="permission-scope-chip"
							  [ngClass]="{
								'scope-anonymous': item.permissions?.link?.scope === 'anonymous',
								'scope-external': item.permissions?.link?.scope === 'external',
								'scope-organization': item.permissions?.link?.scope === 'organization',
								'scope-users': item.permissions?.link?.scope === 'users'
							  }">
							{{item.permissions?.link?.scope === 'organization' ? 'Organization Link' : (item.permissions?.link?.scope | titlecase)}}
						</span>
						<i style="font-weight: 400; font-size: 11px;" class="far fa-question-circle opacity-50"
						   [tooltip]="linkScopeTooltips[item.permissions?.link?.scope]" placement="right"></i>
					</div>
				</div>

			</ng-template>
		</trustifi-table-c>
	</div>
</popup-c>

<collaboration-asset-info
	*ngIf="currentAssetInfoObj"
	[asset]="currentAssetInfoObj"
	(closeCb)="currentAssetInfoObj = null;">
</collaboration-asset-info>
